import React, { Component } from 'react';
import { post } from '../../util/api';
import { Segment, Table, Tab, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';

export default class MainTable extends Component {
	state = {
		loading: true,
	};
	componentDidMount() {
		this.postData();
	}
	async postData() {
		await post('/live/admin/instagramUsers').then((data) => this.setState({ data: data.data.result, loading: false }));
	}
	render() {
		let { loading, data } = this.state;
		if (loading) return <Segment attached="bottom">loading...</Segment>;
		return (
			<div style={{ display: 'flex', maxHeight: '95%' }}>
				<Tab.Pane attached={true} style={{ overflow: 'auto', padding: 0 }}>
					<Table>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell>Email</Table.HeaderCell>
								<Table.HeaderCell>Connected</Table.HeaderCell>
								<Table.HeaderCell>Account Name</Table.HeaderCell>
								<Table.HeaderCell>Update Date</Table.HeaderCell>
							</Table.Row>
						</Table.Header>
						<Table.Body>
							{_.map(data, (o) => (
								<Table.Row>
									<Table.Cell>{o.email}</Table.Cell>
									<Table.Cell>{o.accessToken ? <Icon name="check" color="green"></Icon> : <Icon name="close" color="red"></Icon>}</Table.Cell>
									<Table.Cell>{o.data.connected_instagram_account_name || o.data.connected_instagram_account_id}</Table.Cell>
									<Table.Cell>{moment(o.updated_at).format('DD-MM-YYYY')}</Table.Cell>
								</Table.Row>
							))}
						</Table.Body>
					</Table>
				</Tab.Pane>
			</div>
		);
	}
}
